import React from 'react';
import builderPathInit from '../../util/builder-path-init';

import okendoReviewsBuilderConfig from
  '../../components/okendo-reviews/okendo-reviews.builder.config';
import OkendoReviews from '../../components/okendo-reviews/okendo-reviews';

const { BuilderPage, getServerSideProps } = builderPathInit({
  model: 'builder-page',
  pathPrefix: 'b',
  components: [
    {
      config: okendoReviewsBuilderConfig,
      component: OkendoReviews,
    },
  ],
});

function MarketingPage(props) {
  return <BuilderPage {...props} />;
}

export default MarketingPage;
export { getServerSideProps };
